var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.component && !_vm.isHidden)?_c(_vm.component,{tag:"component",attrs:{"data":_vm.restProps}},_vm._l((_vm.restProps.children),function(child,i){return _c('ContentTypeFactory',{key:i,attrs:{"data":child}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }